import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  DeviceAddRequest,
  DeviceAddResponse,
  DeviceBuySellRequest,
  DeviceBuySellResponse,
  DevicePartBuySellRequest,
  DevicePartListResponse,
  DeviceUpdateRequest,
  DeviceUpdateResponse,
  StaffListResponse,
} from "./Stock.constants";
import axiosInstance from "../../shared/service/axios";

//////////////////////////////////////// DEVİCEEEE

export const useDeviceAddMutation = (): UseMutationResult<
  DeviceAddResponse,
  AxiosError,
  DeviceAddRequest
> =>
  useMutation<DeviceAddResponse, AxiosError, DeviceAddRequest>(
    async (requestValues: DeviceAddRequest) => {
      const { data, status } = await axiosInstance.post(
        "device/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useDeviceUpdateMutation = (): UseMutationResult<
  DeviceUpdateResponse,
  AxiosError,
  DeviceUpdateRequest
> =>
  useMutation<DeviceUpdateResponse, AxiosError, DeviceUpdateRequest>(
    async (requestValues: DeviceUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "device/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useDeviceListMutation = (): UseMutationResult<
  StaffListResponse,
  AxiosError,
  any
> =>
  useMutation<StaffListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("device/");
    data.status = status;

    return data;
  });

export const useDeviceDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  string
> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete(
      "device/" + requestValues + "/"
    );

    return status;
  });

//////////////////////////////////////// DEVİCEEEE PARTTTTT

export const useDevicePartListMutation = (): UseMutationResult<
  DevicePartListResponse,
  AxiosError,
  any
> =>
  useMutation<DevicePartListResponse, AxiosError, any>(async () => {
    const { data, status } = await axiosInstance.get("device/part/");
    data.status = status;

    return data;
  });

export const useDevicePartUpdateMutation = (): UseMutationResult<
  DeviceUpdateResponse,
  AxiosError,
  DeviceUpdateRequest
> =>
  useMutation<DeviceUpdateResponse, AxiosError, DeviceUpdateRequest>(
    async (requestValues: DeviceUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "device/part/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useDevicePartAddMutation = (): UseMutationResult<
  DeviceAddResponse,
  AxiosError,
  DeviceAddRequest
> =>
  useMutation<DeviceAddResponse, AxiosError, DeviceAddRequest>(
    async (requestValues: DeviceAddRequest) => {
      const { data, status } = await axiosInstance.post(
        "device/part/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useDevicePartDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  string
> =>
  useMutation<any, AxiosError, string>(async (requestValues: string) => {
    const { status } = await axiosInstance.delete(
      "device/part/" + requestValues + "/"
    );

    return status;
  });

/////////////////// BUY SELL /////////////////////
export const useDeviceBuySellMutation = (): UseMutationResult<
  DeviceBuySellResponse,
  AxiosError,
  DeviceBuySellRequest
> =>
  useMutation<DeviceBuySellResponse, AxiosError, DeviceBuySellRequest>(
    async (requestValues: DeviceBuySellRequest) => {
      const { data, status } = await axiosInstance.post(
        "device/transaction/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useDevicePartBuySellMutation = (): UseMutationResult<
  DeviceBuySellResponse,
  AxiosError,
  DevicePartBuySellRequest
> =>
  useMutation<DeviceBuySellResponse, AxiosError, DevicePartBuySellRequest>(
    async (requestValues: DevicePartBuySellRequest) => {
      const { data, status } = await axiosInstance.post(
        "device/part/transaction/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );
